<template>
  <ul
    class="pagination flex__center flex-aligncenter"
    v-show="totalPageCount > 0"
    style="
      padding: 40px 0;
      position: sticky;
      bottom: 0;
      background-color: #ffffff;
    "
  >
    <li class="arrow pprev"><a @click="onClickFirstPage">맨앞으로</a></li>
    <li class="arrow prev"><a @click="onClickPreviousPage">이전으로</a></li>
    <li class="page">
      <a
        :class="{ clicked: pageIndex === currentIndex }"
        v-for="pageIndex in pageList"
        :key="pageIndex"
        @click="onClickPage(pageIndex)"
        >{{ pageIndex }}</a
      >
    </li>
    <li class="arrow next"><a @click="onClickNextPage">다음으로</a></li>
    <li class="arrow nnext"><a @click="onClickLastPage">끝으로</a></li>
  </ul>
</template>

<script>
import { computed } from "vue";

export default {
  name: "SearchPagination",
  data() {
    return {};
  },
  props: {
    currentIndex: {
      type: Number,
      default: 1,
    },
    totalPageCount: {
      type: Number,
      default: 1,
    },
    pageDisplayCount: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    // 현재 페이지의 그룹 번호
    currentPageGroup() {
      return Math.ceil(this.currentIndex / this.pageDisplayCount);
    },
    // 마지막 페이지 번호
    lastPageNumber() {
      const lastNumber = this.currentPageGroup * this.pageDisplayCount;
      return lastNumber > this.totalPageCount
        ? this.totalPageCount
        : lastNumber;
    },
    // 첫번째 페이지 번호
    firstPageNumber() {
      if (this.lastPageNumber === this.totalPageCount) {
        const multipleOfPageDisplayCount =
          this.lastPageNumber % this.pageDisplayCount === 0;
        return multipleOfPageDisplayCount
          ? this.lastPageNumber - this.pageDisplayCount + 1
          : this.lastPageNumber -
              (this.lastPageNumber % this.pageDisplayCount) +
              1;
      }
      return this.lastPageNumber - (this.pageDisplayCount - 1);
    },
    // 페이지 리스트
    pageList() {
      const list = [];
      for (let i = this.firstPageNumber; i <= this.lastPageNumber; i++) {
        list.push(i);
      }
      return list;
    },
    // 다음 버튼 비활성화
    nextButtonDisabled() {
      return this.lastPageNumber >= this.totalPageCount;
    },
    // 이전 버튼 비활성화
    previousButtonDisabled() {
      return this.firstPageNumber <= 1;
    },
  },
  methods: {
    onClickPage(pageIndex) {
      if (pageIndex === this.currentIndex) return false;
      this.$emit("onClickIndex", pageIndex);
    },
    onClickNextPage() {
      this.$emit(
        "onClickIndex",
        this.totalPageCount !== this.currentIndex
          ? this.currentIndex + 1
          : this.totalPageCount
      );
    },
    onClickPreviousPage() {
      this.$emit(
        "onClickIndex",
        this.currentIndex > 1 ? this.currentIndex - 1 : 1
      );
    },
    onClickFirstPage() {
      this.$emit("onClickIndex", 1);
    },
    onClickLastPage() {
      this.$emit("onClickIndex", this.totalPageCount);
    },
  },
};
</script>

<style scoped>
.flex__center {
  display: flex;
  justify-content: center;
}
.pagination {
  gap: 5px;
  z-index: 10;
}
.pagination li.page {
  display: flex;
  gap: 5px;
}
.pagination li.page a {
  font-size: 18px;
  cursor: pointer;
}
.pagination li.page a.clicked {
  color: #8e80f2;
  font-weight: 700;
}
.arrow a {
  display: block;
  background-repeat: no-repeat;
  text-indent: -9999px;
  width: 14px;
  background-position: center;
  cursor: pointer;
}
.pprev a {
  background-image: url("../../assets/img/arrow-pprev.png");
}
.prev a {
  background-image: url("../../assets/img/arrow-prev.png");
}
.next a {
  background-image: url("../../assets/img/arrow-next.png");
}
.nnext a {
  background-image: url("../../assets/img/arrow-nnext.png");
}
.page {
  margin: 0 10px;
}
.page a {
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;
}
.page a::before {
  content: "";
  width: 4px;
  height: 4px;
  display: inline-flex;
  background-color: #8e80f2;
  border-radius: 50%;
}
.page a:first-child::before {
  display: none;
}
</style>
